import zhHans from './zh-Hans'

export default {
  'zh-Hans': zhHans,
}
